var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBriefcase = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.74999 1.49996C8.02064 1.49996 7.32117 1.78969 6.80544 2.30542C6.28972 2.82114 5.99999 3.52062 5.99999 4.24996L5.99998 6H2.75C1.23122 6 0 7.23122 0 8.75V19.75C0 21.2688 1.23122 22.5 2.75 22.5H21.25C22.7688 22.5 24 21.2688 24 19.75V8.75C24 7.23122 22.7688 6 21.25 6H18V4.28744C18 3.55809 17.7103 2.85862 17.1945 2.3429C16.6788 1.82717 15.9793 1.53744 15.25 1.53744L8.74999 1.49996ZM16.5 6V4.28744C16.5 3.95592 16.3683 3.63798 16.1339 3.40356C15.8995 3.16914 15.5815 3.03744 15.25 3.03744L8.74999 2.99996C8.41846 2.99996 8.10052 3.13166 7.8661 3.36608C7.63168 3.6005 7.49999 3.91844 7.49999 4.24996L7.49998 6H16.5ZM7.49998 7.5H16.5V21H7.49996L7.49998 7.5ZM5.99998 7.5H2.75C2.05964 7.5 1.5 8.05964 1.5 8.75V19.75C1.5 20.4403 2.05964 21 2.75 21H5.99996L5.99998 7.5ZM18 21V7.5H21.25C21.9404 7.5 22.5 8.05964 22.5 8.75V19.75C22.5 20.4403 21.9404 21 21.25 21H18Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/briefcase.697d891c227adfb7e7edf075417d9e7a.svg";